import { getAnalyticsItemType } from '@mb/lib';
import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { pushLearnMoreCtaClickDataLayer } from './pushLearnMoreCtaClickDataLayer';
import { pushLearnMoreInteraction } from './pushLearnMoreInteraction';
import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';

type Props = {
  product: ProductSearchMaterial;
  isLearnMoreNewTab?: boolean;
  dataLayerAnalytics?: {
    listId: string;
    listName: string;
    eventLocation: string;
  };
};

export const handleMiniPdpDetailsClickDataLayer = ({
  product,
  isLearnMoreNewTab = false,
  dataLayerAnalytics,
}: Props) => {
  if (!product) return;

  if (product?.isDigital) {
    pushLearnMoreCtaClickDataLayer([
      {
        ...getAnalyticsItemCategoriesByTaxonomy(product?.taxonomy || []),
        item_name: product?.name,
        item_brand: product?.manufacturer,
        item_type: getAnalyticsItemType(product),
        item_id: product?.entityId,
        item_variant: product?.name,
        item_list_id: dataLayerAnalytics?.listId ?? 'digital_sampling',
        item_list_name: dataLayerAnalytics?.listName ?? 'digital sampling',
        event_location: dataLayerAnalytics?.eventLocation ?? 'Quick View',
        index: 1,
        quantity: 1,
        price: 0,
      },
    ]);
  } else {
    pushLearnMoreInteraction([
      {
        item_id: product?.entityId,
        item_name: product?.name,
        item_brand: product?.manufacturer,
        item_type: getAnalyticsItemType(product),
        ...getAnalyticsItemCategoriesByTaxonomy(product?.taxonomy),
        index: 1,
        price: 0,
        quantity: 1,
        item_list_id: dataLayerAnalytics?.listId ?? 'quick_view',
        item_list_name: dataLayerAnalytics?.listName ?? 'Quick View',
        event_location: dataLayerAnalytics?.eventLocation ?? 'Quick View',
        item_variant: product?.name,
      },
    ]);
  }

  window.open(product?.url, isLearnMoreNewTab ? '_blank' : '_self');
};
